import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html',
  styleUrls: ['./yes-no-dialog.component.scss']
})
export class YesNoDialogComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;

  constructor(protected ref: NbDialogRef<any>) { }

  ngOnInit(): void {
  }

  onClickYes() {
    this.ref.close(true);
  }

  onClickNo() {
    this.ref.close(false);
  }

}
